import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { SET_IS_CURATION_ENABLED_LOCATION_TYPE_OR_LOCATION_TYPE_CATEGORY_MUTATION } from '../graphql/mutations'
import { SET_IS_CURATION_ENABLED_LOCATION_TYPE_OR_LOCATION_TYPE_CATEGORY } from '../redux/action-types'

const useSetIsCurationEnabledLocationTypeOrLocationTypeCategoryMutation =
  refetchLastEvent => {
    const dispatch = useDispatch()

    const { isLoading, error } = useSelector(
      store => store.locationTypes.locationTypesAndLocationTypeCategories,
    )

    const mutate = useCallback(
      async (id, isCurationEnabled, type) => {
        await apolloService.mutate(
          SET_IS_CURATION_ENABLED_LOCATION_TYPE_OR_LOCATION_TYPE_CATEGORY_MUTATION,
          {
            id,
            isCurationEnabled,
            type,
          },
          dispatch,
          SET_IS_CURATION_ENABLED_LOCATION_TYPE_OR_LOCATION_TYPE_CATEGORY,
        )

        refetchLastEvent()
      },
      [dispatch, refetchLastEvent],
    )

    return [mutate, { isLoading, error }]
  }

export default useSetIsCurationEnabledLocationTypeOrLocationTypeCategoryMutation
